import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AddressLookup } from '../../../../shared';
import { setLoading } from '../../duck/basic';
import {
  addDealerToContract,
  replaceDealer,
  changePricebook,
  updateDealer,
  updateDealerWithDefault,
} from '../../duck/dealer';
import { updateSalesperson } from '../../duck/salesperson';
import {
  Form,
  Icon,
  Message,
  Radio,
  Segment,
} from 'semantic-ui-react';
import ViewOnly from './ViewOnly';

class Dealer extends Component {
  state = {
    dealers: [],
    loading: false,
    salespeople: [],
  }

  componentDidMount = () => {
    if (!this.props.payment || !this.props.dealerId) {
      this.fetchDealers();

      if (this.props.dealer) {
        this.fetchSalespeople(this.props.dealer.id)
      }
    }
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.dealer !== this.props.dealer && !this.props.payment) {
      this.fetchSalespeople(this.props.dealer.id);
    }
  }

  fetchDealers = () => {
    this.props.dispatch(setLoading(true))

    axios.get('/dealers/')
      .then(({ data }) => {
        const dealers = data.dealers.sort((a, b) => a.name.localeCompare(b.name));
        this.setState({
          dealers,
          loading: false,
        });
      })
      .then(() => this.props.dispatch(setLoading(false)))
  }

  fetchSalespeople = (dealerId) => {
    this.props.dispatch(setLoading(true))
    axios.post('/fetch-salespeople/', { dealer_id: dealerId })
      .then(({ data }) => {
        this.setState({
          salespeople: data,
        });
      })
      .then(() => this.props.dispatch(setLoading(false)))
      .catch((err) => {

      })
  }

  handlePricebookChange = (e, d) => {
    const { value } = d;

    if (value == 'true') {
      this.props.dispatch(changePricebook(true, this.props.id));
    } else {
      this.props.dispatch(changePricebook(false, this.props.id));
    }
  }

  onDealerSelect = (id) => {
    const dealer = this.state.dealers.find(d => d.id === id);

    if (!dealer || this.props.dealer && this.props.dealer.id === id) {
      return;
    }

    if (this.props.systems.length && !this.props.dealer) {
      return this.props.dispatch(updateDealerWithDefault(dealer, this.props.id));
    }

    if (this.props.dealer) {
      return this.props.dispatch(replaceDealer(dealer, this.props.id));
    }

    if (!this.props.dealer) {
      return this.props.dispatch(addDealerToContract(dealer, this.props.id));
    }

    this.props.dispatch(updateDealer(dealer, this.props.id));
  }

  onSalespersonSelect = (id) => {
    const salesperson = this.state.salespeople.find(d => d.id === id);

    if (!salesperson) {
      return;
    }

    this.props.dispatch(updateSalesperson(salesperson, this.props.id));
  }

  render() {
    const {
      dealer,
      salesperson,
    } = this.props;

    const dealerValue = dealer ? dealer.id : null;

    const dealerOptions = this.state.dealers.map((d) => ({
      key: d.id,
      text: `${d.name}${d.is_financial ? ' (is financial)' : ''}`,
      value: d.id,
    }));

    const salespersonOptions = this.state.salespeople.map(s => {
      return ({
        key: s.id,
        text: `${s.first_name} ${s.last_name}`,
        value: s.id,
      });
    });

    if (this.props.payment) {
      return (
        <ViewOnly
          dealer={this.props.dealer}
          salesperson={this.props.salesperson}
        />
      );
    }

    return (
      <Segment padded>
        {
          /*
            <AddressLookup />
          */
        }
        <Form size="large">
          <Form.Select
            placeholder="Select a dealer..."
            label="Dealer"
            search
            loading={this.state.loading}
            selection
            fluid
            options={dealerOptions}
            onChange={(e, d) => this.onDealerSelect(d.value)}
            value={this.state.dealers.find(d => d.id === dealerValue) ? dealerValue : null}
          />
          {
            salespersonOptions.length > 0 &&
              <Form.Select
                placeholder="Select a salesperson..."
                search
                label="Salesperson"
                loading={this.state.loading}
                selection
                fluid
                options={salespersonOptions}
                onChange={(e, d) => this.onSalespersonSelect(d.value)}
                value={salesperson ? salesperson.id : null}
              />
          }
        </Form>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return {
    dealer: state.dealer,
    defaultPricebook: state.defaultPricebook,
    id: state.id,
    loading: state.loading,
    payment: state.payment,
    salesperson: state.salesperson,
    showPricebookSelect: state.showPricebookSelect,
    systems: state.systems,
    term: state.term,
  }
}

export default connect(mapStateToProps)(Dealer);
